// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  min-height: 100%;
  background-color: var(--sebrae-light-gray);
  color: var(--sebrae-gray);
  padding-top: 56px;
}
.onboarding.on-onboarding {
  padding-top: 0;
  min-height: var(--sebrae-full-height);
}
@media screen and (min-width: 1024px) {
  .onboarding.on-onboarding {
    min-height: calc(100dvh - 60px);
  }
}
.onboarding .content {
  position: relative;
  height: 100%;
}
.onboarding.type-page {
  z-index: 1;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
}
.onboarding__dots {
  margin-bottom: 10px;
}
.onboarding__dots ul {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  list-style: none;
  padding: 0;
  margin: 0;
}
.onboarding__dots ul li {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: var(--sebrae-light-gray3);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.onboarding__dots ul li.active {
  background-color: var(--sebrae-blue-6);
}
.onboarding .container {
  position: relative;
  padding: 0 24px;
}
.onboarding .container .guide-buttons-area {
  display: flex;
  align-items: center;
  justify-content: center;
}
.onboarding .container .guide-buttons-area button {
  color: var(--sebrae-white);
  width: 238px;
}
.onboarding .container .guide-buttons-area .close-guide {
  cursor: pointer;
  color: var(--sebrae-blue-6);
}
.onboarding .container .guide-buttons-area .close-guide:hover {
  text-decoration: underline;
}
.onboarding__skip {
  font-size: 13px;
  font-weight: 400;
  color: var(--sebrae-blue-6);
  margin: 20px auto 0 !important;
}
.onboarding .wrapper {
  height: inherit;
  padding-bottom: 120px;
}
.onboarding .wrapper.last-step {
  padding-bottom: 65px;
}
.onboarding__footer {
  background-color: var(--sebrae-light-gray);
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  text-align: center;
  z-index: 1;
  padding-bottom: 15px;
}
.onboarding__footer .BaSe--button span {
  font-size: 13px;
  font-weight: 700;
}
.onboarding h2 {
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
}
.onboarding p {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
}
.onboarding .step figure {
  margin: 16px auto 20px;
  min-height: 145px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.onboarding .step figure img {
  width: 170px;
  margin: 0 auto;
}
.onboarding .wrapper-texts {
  text-align: center;
  margin-bottom: 25px;
}
@media screen and (min-width: 320px) {
  .onboarding__dots ul {
    position: relative;
    z-index: 2;
    gap: 8px;
  }
  .onboarding__dots ul li {
    width: 10px;
    height: 10px;
  }
  .onboarding .container .guide-buttons-area {
    flex-direction: column-reverse;
    gap: 28px;
    padding: 0 24px 20px;
  }
}
@media screen and (min-width: 360px) {
  .onboarding .container .guide-buttons-area {
    padding: 0 24px;
  }
}
@media screen and (min-width: 375px) {
  .onboarding h2 {
    font-size: 19px;
  }
  .onboarding p {
    font-size: 16px;
  }
  .onboarding .step figure {
    min-height: 166px;
  }
  .onboarding .step figure img {
    width: 195px;
  }
  .onboarding .wrapper-texts {
    margin-bottom: 32px;
  }
}
@media screen and (min-width: 768px) {
  .onboarding .container .guide-buttons-area {
    gap: 131px;
    flex-direction: row;
  }
  .onboarding h2 {
    font-size: 21px;
  }
  .onboarding p {
    font-size: 18px;
  }
  .onboarding .step figure {
    min-height: 255px;
  }
  .onboarding .step figure img {
    width: 300px;
  }
  .onboarding__skip {
    font-size: 16px;
  }
  .onboarding__footer .BaSe--button span {
    font-size: 16px;
  }
}
@media screen and (min-width: 1024px) {
  .onboarding {
    padding-top: 60px;
  }
}
@media screen and (min-width: 1280px) {
  .onboarding .content {
    padding: 50px 0;
  }
  .onboarding .container .guide-buttons-area {
    gap: 130px;
  }
  .onboarding .steps {
    margin: 0 auto;
    width: 100%;
    max-width: 918px;
  }
  .onboarding .step {
    position: relative;
    display: flex;
    justify-content: space-between;
    gap: 120px;
    flex-direction: row-reverse;
    min-height: 339px;
  }
  .onboarding .step figure {
    margin: 0;
    min-height: 340px;
  }
  .onboarding .step figure img {
    width: 400px;
  }
  .onboarding .step .text {
    position: relative;
    max-width: 390px;
  }
  .onboarding .wrapper-texts {
    text-align: left;
  }
  .onboarding h2 {
    font-size: 23px;
    margin-bottom: 22px;
  }
  .onboarding .wrapper {
    padding-bottom: 20px;
    height: auto;
  }
  .onboarding__skip {
    margin: 0 !important;
  }
  .onboarding__footer {
    position: relative;
    margin-top: 50px;
  }
  .onboarding__footer .container {
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .onboarding__footer .BaSe--button {
    max-width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/onboarding/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EAEA,gBAAA;EACA,0CAAA;EACA,yBAAA;EACA,iBAAA;AAAF;AAEE;EACE,cAAA;EACA,qCAAA;AAAJ;AAEI;EAJF;IAKI,+BAAA;EACJ;AACF;AAEE;EACE,kBAAA;EACA,YAAA;AAAJ;AAEE;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,mBAAA;AAAJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AACN;AACM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;EACA,gCAAA;EACA,eAAA;AACR;AACQ;EACE,sCAAA;AACV;AAIE;EACE,kBAAA;EACA,eAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAIM;EACE,0BAAA;EACA,YAAA;AAFR;AAKM;EACE,eAAA;EACA,2BAAA;AAHR;AAKQ;EACE,0BAAA;AAHV;AAQE;EAEI,eAAA;EACA,gBAAA;EAEF,2BAAA;EACA,8BAAA;AARJ;AAUE;EACE,eAAA;EACA,qBAAA;AARJ;AAUI;EACE,oBAAA;AARN;AAWE;EACE,0CAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AATJ;AAWI;EAEI,eAAA;EACA,gBAAA;AAVR;AAcE;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,mBAAA;AAdJ;AAgBE;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;AAhBJ;AAmBI;EACE,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBN;AAmBM;EACE,YAAA;EACA,cAAA;AAjBR;AAqBE;EACE,kBAAA;EACA,mBAAA;AAnBJ;AAsBE;EAEI;IACE,kBAAA;IACA,UAAA;IACA,QAAA;EArBN;EAuBM;IACE,WAAA;IACA,YAAA;EArBR;EA0BI;IACE,8BAAA;IACA,SAAA;IACA,oBAAA;EAxBN;AACF;AA2BE;EAEI;IACE,eAAA;EA1BN;AACF;AA6BE;EACE;IACE,eAAA;EA3BJ;EA6BE;IACE,eAAA;EA3BJ;EA8BI;IACE,iBAAA;EA5BN;EA6BM;IACE,YAAA;EA3BR;EA+BE;IACE,mBAAA;EA7BJ;AACF;AA+BE;EAEI;IACE,UAAA;IACA,mBAAA;EA9BN;EAiCE;IACE,eAAA;EA/BJ;EAiCE;IACE,eAAA;EA/BJ;EAkCI;IACE,iBAAA;EAhCN;EAkCM;IACE,YAAA;EAhCR;EAoCE;IACE,eAAA;EAlCJ;EAqCI;IACE,eAAA;EAnCN;AACF;AAsCE;EAlOF;IAmOI,iBAAA;EAnCF;AACF;AAoCE;EACE;IACE,eAAA;EAlCJ;EAqCI;IACE,UAAA;EAnCN;EAsCE;IACE,cAAA;IACA,WAAA;IACA,gBAAA;EApCJ;EAsCE;IACE,kBAAA;IACA,aAAA;IACA,8BAAA;IACA,UAAA;IACA,2BAAA;IACA,iBAAA;EApCJ;EAsCI;IACE,SAAA;IACA,iBAAA;EApCN;EAsCM;IACE,YAAA;EApCR;EAuCI;IACE,kBAAA;IACA,gBAAA;EArCN;EAwCE;IACE,gBAAA;EAtCJ;EAwCE;IACE,eAAA;IACA,mBAAA;EAtCJ;EAwCE;IACE,oBAAA;IACA,YAAA;EAtCJ;EAwCE;IACE,oBAAA;EAtCJ;EAwCE;IACE,kBAAA;IACA,gBAAA;EAtCJ;EAwCI;IACE,aAAA;IACA,SAAA;IACA,mBAAA;IACA,uBAAA;IACA,sBAAA;EAtCN;EAwCI;IACE,gBAAA;EAtCN;AACF","sourcesContent":[".onboarding {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  //min-height: calc(100dvh - 100px);\n  min-height: 100%;\n  background-color: var(--sebrae-light-gray);\n  color: var(--sebrae-gray);\n  padding-top: 56px;\n\n  &.on-onboarding {\n    padding-top: 0;\n    min-height: var(--sebrae-full-height);\n\n    @media screen and (min-width: 1024px) {\n      min-height: calc(100dvh - 60px);\n    }\n  }\n\n  .content {\n    position: relative;\n    height: 100%;\n  }\n  &.type-page {\n    z-index: 1;\n    display: flex;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n  }\n  &__dots {\n    margin-bottom: 10px;\n    ul {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n\n      li {\n        width: 6px;\n        height: 6px;\n        border-radius: 100%;\n        background-color: var(--sebrae-light-gray3);\n        transition: all 0.3s ease-in-out;\n        cursor: pointer;\n\n        &.active {\n          background-color: var(--sebrae-blue-6);\n        }\n      }\n    }\n  }\n  .container {\n    position: relative;\n    padding: 0 24px;\n\n    .guide-buttons-area {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      button {\n        color: var(--sebrae-white);\n        width: 238px;\n      }\n\n      .close-guide {\n        cursor: pointer;\n        color: var(--sebrae-blue-6);\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n  &__skip {\n    font: {\n      size: 13px;\n      weight: 400;\n    }\n    color: var(--sebrae-blue-6);\n    margin: 20px auto 0 !important;\n  }\n  .wrapper {\n    height: inherit;\n    padding-bottom: 120px;\n\n    &.last-step {\n      padding-bottom: 65px;\n    }\n  }\n  &__footer {\n    background-color: var(--sebrae-light-gray);\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    left: 0;\n    text-align: center;\n    z-index: 1;\n    padding-bottom: 15px;\n\n    .BaSe--button span {\n      font: {\n        size: 13px;\n        weight: 700;\n      }\n    }\n  }\n  h2 {\n    font: {\n      size: 17px;\n      weight: 700;\n    }\n    line-height: 1.2;\n    margin-bottom: 16px;\n  }\n  p {\n    font: {\n      size: 14px;\n      weight: 400;\n    }\n    line-height: 1.2;\n  }\n  .step {\n    figure {\n      margin: 16px auto 20px;\n      min-height: 145px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      img {\n        width: 170px;\n        margin: 0 auto;\n      }\n    }\n  }\n  .wrapper-texts {\n    text-align: center;\n    margin-bottom: 25px;\n  }\n\n  @media screen and (min-width: 320px) {\n    &__dots {\n      ul {\n        position: relative;\n        z-index: 2;\n        gap: 8px;\n\n        li {\n          width: 10px;\n          height: 10px;\n        }\n      }\n    }\n    .container {\n      .guide-buttons-area {\n        flex-direction: column-reverse;\n        gap: 28px;\n        padding: 0 24px 20px;\n      }\n    }\n  }\n  @media screen and (min-width: 360px) {\n    .container {\n      .guide-buttons-area {\n        padding: 0 24px;\n      }\n    }\n  }\n  @media screen and (min-width: 375px) {\n    h2 {\n      font-size: 19px;\n    }\n    p {\n      font-size: 16px;\n    }\n    .step {\n      figure {\n        min-height: 166px;\n        img {\n          width: 195px;\n        }\n      }\n    }\n    .wrapper-texts {\n      margin-bottom: 32px;\n    }\n  }\n  @media screen and (min-width: 768px) {\n    .container {\n      .guide-buttons-area {\n        gap: 131px;\n        flex-direction: row;\n      }\n    }\n    h2 {\n      font-size: 21px;\n    }\n    p {\n      font-size: 18px;\n    }\n    .step {\n      figure {\n        min-height: 255px;\n\n        img {\n          width: 300px;\n        }\n      }\n    }\n    &__skip {\n      font-size: 16px;\n    }\n    &__footer {\n      .BaSe--button span {\n        font-size: 16px;\n      }\n    }\n  }\n  @media screen and (min-width: 1024px) {\n    padding-top: 60px;\n  }\n  @media screen and (min-width: 1280px) {\n    .content {\n      padding: 50px 0;\n    }\n    .container {\n      .guide-buttons-area {\n        gap: 130px;\n      }\n    }\n    .steps {\n      margin: 0 auto;\n      width: 100%;\n      max-width: 918px;\n    }\n    .step {\n      position: relative;\n      display: flex;\n      justify-content: space-between;\n      gap: 120px;\n      flex-direction: row-reverse;\n      min-height: 339px;\n\n      figure {\n        margin: 0;\n        min-height: 340px;\n\n        img {\n          width: 400px;\n        }\n      }\n      .text {\n        position: relative;\n        max-width: 390px;\n      }\n    }\n    .wrapper-texts {\n      text-align: left;\n    }\n    h2 {\n      font-size: 23px;\n      margin-bottom: 22px;\n    }\n    .wrapper {\n      padding-bottom: 20px;\n      height: auto;\n    }\n    &__skip {\n      margin: 0 !important;\n    }\n    &__footer {\n      position: relative;\n      margin-top: 50px;\n\n      .container {\n        display: flex;\n        gap: 24px;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n      }\n      .BaSe--button {\n        max-width: 200px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
